import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return {
      ...data,
      person: props.person ?? data.person,
      patient_id: props.patient_id ?? data.patient_id,
    }
  }, [data, props.patient_id, props.person])
}
